// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.personalization-container {
    background-color: rgb(236, 236, 236);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 900px;
    width: 80%;
    min-height: 500px;
    border: 1px solid rgb(187, 187, 187);
    border-radius: 12px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 10px;
    padding-bottom: 20px;
}

.flex-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}

.personalization-buttons {
    display: flex;
    flex-direction: column;
    margin: 10px;
    margin-top: -10px;
}

.personalization-buttons > button {
    width: 100%;
    min-width: 200px;
    max-width: 300px;
    white-space: normal;
    word-wrap: break-word;
}

.colorPicker {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
    margin-bottom: -20px;
}

.personalization_global {
    width: 300px;
    height: 400px;
    border: 1px solid black;
    margin: 10px;
    margin-bottom: -30px;
}

.personalization_header {
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
}

.personalization_header > input {
    font-size: 12px;
    text-align: center;
    border: none;
    background-color: transparent;
    outline: none;
    text-decoration: underline;
    font-weight: bold;
}

.personalization_body {
    height: 250px;
}

.personalization_footer {
    height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/style/Register/Personalization.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".personalization-container {\r\n    background-color: rgb(236, 236, 236);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    max-width: 900px;\r\n    width: 80%;\r\n    min-height: 500px;\r\n    border: 1px solid rgb(187, 187, 187);\r\n    border-radius: 12px;\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    padding: 10px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.flex-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.personalization-buttons {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 10px;\r\n    margin-top: -10px;\r\n}\r\n\r\n.personalization-buttons > button {\r\n    width: 100%;\r\n    min-width: 200px;\r\n    max-width: 300px;\r\n    white-space: normal;\r\n    word-wrap: break-word;\r\n}\r\n\r\n.colorPicker {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 10px;\r\n    margin-bottom: -20px;\r\n}\r\n\r\n.personalization_global {\r\n    width: 300px;\r\n    height: 400px;\r\n    border: 1px solid black;\r\n    margin: 10px;\r\n    margin-bottom: -30px;\r\n}\r\n\r\n.personalization_header {\r\n    height: 100px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 12px;\r\n}\r\n\r\n.personalization_header > input {\r\n    font-size: 12px;\r\n    text-align: center;\r\n    border: none;\r\n    background-color: transparent;\r\n    outline: none;\r\n    text-decoration: underline;\r\n    font-weight: bold;\r\n}\r\n\r\n.personalization_body {\r\n    height: 250px;\r\n}\r\n\r\n.personalization_footer {\r\n    height: 50px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
